import {
  getUploadedResourceKind,
  type UploadedResource,
} from "./uploadedResources"

export type MentionKind = "audio" | "image" | "video"

export type MentionResource = UploadedResource & {
  kind: MentionKind
  label: string
  mentionId: string
}

const imageMentionPattern = /@图片(\d+)/g

export const reconcileImageMentionLabels = (
  value: string,
  previousUrls: string[],
  nextUrls: string[],
  options?: { preserveReplacedPositions?: boolean },
) => {
  const nextIndexByUrl = new Map(
    nextUrls.map((url, index) => [url, index + 1] as const),
  )
  let removedCount = 0

  const nextValue = value.replace(
    imageMentionPattern,
    (mention, indexText: string) => {
      const previousIndex = Number(indexText) - 1
      const previousUrl = previousUrls[previousIndex]
      const nextIndex = previousUrl
        ? nextIndexByUrl.get(previousUrl)
        : undefined

      if (nextIndex) return `@图片${nextIndex}`

      if (options?.preserveReplacedPositions && nextUrls[previousIndex]) {
        return mention
      }

      if (previousUrl) {
        removedCount += 1
        return ""
      }

      return mention
    },
  )

  return {
    removedCount,
    value: nextValue,
  }
}

export const getMentionResources = (resources: UploadedResource[]) => {
  let audioIndex = 0
  let imageIndex = 0
  let videoIndex = 0

  return resources
    .filter((resource) => {
      return getUploadedResourceKind(resource) !== "file"
    })
    .map((resource) => {
      const kind = getUploadedResourceKind(resource) as MentionKind

      let label: string
      switch (kind) {
        case "image":
          imageIndex += 1
          label = `图片${imageIndex}`
          break
        case "video":
          videoIndex += 1
          label = `视频${videoIndex}`
          break
        default:
          audioIndex += 1
          label = `音频${audioIndex}`
      }
      const mentionId = resource.id || resource.url

      return {
        id: resource.id,
        kind,
        label,
        mentionId,
        name: resource.name,
        size: resource.size,
        type: resource.type,
        uploadedAt: resource.uploadedAt,
        url: resource.url,
      } satisfies MentionResource
    })
}
